module.exports = __webpack_public_path__ + "img/gs.6b4bf37b.svg";